export default "__VITE_ASSET__15b469f0__"